import { Component, Input, OnInit } from '@angular/core';
import { texts } from './candidate-status-badge.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-status-badge',
  templateUrl: './candidate-status-badge.component.html',
  styleUrls: ['./candidate-status-badge.component.scss']
})
export class CandidateStatusBadgeComponent implements OnInit {

  @Input()
  assignment : any;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit() {
  }
}
